module.exports = __webpack_public_path__ + "src/assets/img/google/google-calendar-logo-horizontal.49c3c3b7b68d5b2bcdb3f6a15fd72571.png";